const CONFIGURATION = {
  BASE_URL: "/undefined",
  HELP_URL: "https://help.netilion.endress.com",
  HELP_URL_: "https://help.netilion.endress.com",
  MAIN_URL: "https://netilion.endress.com",
  HELP_URL_AVAILABILITY:
    "https://help.netilion.endress.com/hc/en-us/articles/360009713059",
  HELP_URL_DEMODATA:
    "https://help.netilion.endress.com/hc/en-us/articles/4407831766802",
  CONTACT_URL: "https://netilion.endress.com/contact/form",
  SIGN_UP_SURVEY: "https://www.surveymonkey.com/r/help-us-improve-netilion",
  SIGN_UP_VIDEO:
    "https://res.cloudinary.com/hpnfc0f7b/video/upload/v1633611742/FirstAsset_v2_.mp4",
  LEGAL_URL: "/legal",
  HELP_URL_DIGITAL_TWINS:
    "https://help.netilion.endress.com/hc/en-us/articles/13233308259740-Using-digital-twins-across-companies",
  planPriceDisplay: "yearly",
  QAS_MYENDRESS_SSO_LOGOUT_URL:
    "https://myendresstest.b2clogin.com/myendresstest.onmicrosoft.com/b2c_1a_signin/oauth2/v2.0/logout",
  MYENDRESS_SSO_LOGOUT_URL:
    "https://myendress.b2clogin.com/myendress.onmicrosoft.com/b2c_1a_signin/oauth2/v2.0/logout",
};

export function configureApplication(configuration: $TSFixMe) {
  Object.keys(configuration).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    CONFIGURATION[key] = configuration[key];
  });
}

export default CONFIGURATION;
